const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
const SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (
        elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
      ) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute("data-cascade"))
          elementTarget.setAttribute("style", `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

/**
 * Safe helper: returns a root that supports querySelectorAll.
 */
function getQueryRoot(rootEl) {
  if (rootEl && typeof rootEl.querySelectorAll === "function") return rootEl;
  return document;
}

function initializeScrollAnimationTrigger(
  rootEl = document,
  isDesignModeEvent = false,
) {
  const root = getQueryRoot(rootEl);

  const animationTriggerElements = Array.from(
    root.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME),
  );

  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add("scroll-trigger--design-mode");
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: "0px 0px -50px 0px",
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// التعديل: تأخير تشغيل الانيميشن لتقليل الضغط على المعالج
window.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    // تشغيل الدالة بعد مرور 3000 ملي ثانية (3 ثواني)
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(() => initializeScrollAnimationTrigger());
    } else {
      initializeScrollAnimationTrigger();
    }
  }, 3000);
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) =>
    initializeScrollAnimationTrigger(event.target, true),
  );
  document.addEventListener("shopify:section:reorder", () =>
    initializeScrollAnimationTrigger(document, true),
  );
}
